import { useEffect, useState } from "react"

const useSessionStorage = (key: string, value: string): [string, (value: string) => void] => {
	const [stored, setStored] = useState(value)
	useEffect(() => {
		const value = sessionStorage.getItem(key)
		if (value) setStored(value)
	}, [key])
	const setValue = (value: string) => {
		sessionStorage.setItem(key, value)
		setStored(value)
	}
	return [stored, setValue]
}
export default useSessionStorage
